import { Trans, useTranslation } from 'react-i18next';

import { PRIVACY_POLICY_URL } from '@percent/hosted-validation-form/constants/privacyPolicyUrl';
import { TERMS_URL } from '@percent/hosted-validation-form/constants/termsUrl';
import { ReactComponent as Expand } from '@percent/hosted-validation-form/assets/icons/expand.svg';
import { Stepper as BaseStepper, StepperStep, Typography } from '@percent/lemonade';
import { Link } from 'react-router-dom';

import styles from './Stepper.module.scss';

export const Stepper = () => {
  const { t } = useTranslation();

  return (
    <BaseStepper
      classNames={{ stepCompletedIcon: styles.stepper, root: styles.stepRoot }}
      iconSize={32}
      orientation="vertical"
      active={2}
    >
      <StepperStep
        label={
          <Typography className={styles.label} variant="large-bold">
            {t('hostedValidation.stepper.representative')}
          </Typography>
        }
      />
      <StepperStep
        label={
          <Typography className={styles.label} variant="large-bold">
            <Trans t={t} i18nKey="hostedValidation.stepper.agreeTerms">
              You've read Goodstack's{' '}
              <Link className={styles.link} target="_blank" to={TERMS_URL} rel="noopener noreferrer">
                terms & conditions <Expand />
              </Link>
              and{' '}
              <Link className={styles.link} target="_blank" to={PRIVACY_POLICY_URL} rel="noopener noreferrer">
                privacy policy <Expand />
              </Link>
            </Trans>
          </Typography>
        }
      />
    </BaseStepper>
  );
};
